module.exports = __webpack_public_path__ + "static/media/item_16_6_comp.c718e1ec.png";